/*
 * Author: Roger
 * File Created: Friday, 24-07-26 12:02 am
 * Last Modified: Tuesday, 24-11-19 08:23 pm, by Roger
 */

// update from https://www.figma.com/design/w89XIcAJwfzL0E1KIJzPkq/DeCard%E8%A7%84%E8%8C%83?node-id=244-1214&node-type=canvas&m=dev
function Selected() {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" data-sentry-element="svg" data-sentry-component="Selected" data-sentry-source-file="index.tsx">
      <path fillRule="evenodd" clipRule="evenodd" d="M18.8013 7.66341C19.1466 8.02092 19.1368 8.59068 18.7792 8.93601L11.1891 16.2674C10.6227 16.8145 9.71843 16.7929 9.17875 16.2195L5.19091 11.9824C4.85025 11.6205 4.86751 11.0509 5.22946 10.7102C5.59142 10.3696 6.16101 10.3868 6.50167 10.7488L10.2207 14.7002L17.5287 7.64134C17.8862 7.29601 18.456 7.30589 18.8013 7.66341Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
}
export default Selected;